// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { ProjectFinalizationInfoVO, ProjectVO } from './project.vo';
import { UserProfileVO } from '@user/model/vo/user.vo';
import { ReportVO } from './report.vo';
import { CameraParametersVO } from '@3d-scene/camera-parameters.vo';
import { PropertyVO } from '../../components/article/model/vo/property.vo';

@JsonObject('ProjectFinalizationPreviewDTO')
export class ProjectFinalizationPreviewDTO {
  @JsonProperty('localeKey', 'string')
  public localeKey: string;
  @JsonProperty('projectVO', 'ProjectVO')
  public projectVO: ProjectVO;
  @JsonProperty('projectFinalizationInfoVO', 'ProjectFinalizationInfoVO')
  public projectFinalizationInfoVO: ProjectFinalizationInfoVO;
  @JsonProperty('userProfile', 'UserProfileVO')
  public userProfile: UserProfileVO;
  @JsonProperty('reportsVO', 'ReportVO[]')
  public reportsVO: ReportVO[];
  @JsonProperty('projectProperty', 'PropertyVO[]')
  public projectProperty: PropertyVO[];
  @JsonProperty('cameraParameters', 'CameraParametersVO')
  public cameraParameters: CameraParametersVO;
  @JsonProperty('timeZone', 'string')
  public timeZone: string;
}
